module.exports = [
	{
		"name": "Pedro",
		"email": "pedro@auth0.com",
		"gravatarUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-1-0b0477ce8b.png",
		"profile": {
			"position": "VP of Product",
			"company": "Auth0",
			"hobbies": "Baseball, Diving",
			"age": "42",
			"location": "Jersey City, US"
		},
		"sampleAppUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-1-app-3538cb3cff.jpg",
		"connection": {
			"name": "DB-connection-1",
			"icon": "db"
		}
	},
	{
		"name": "Maggie",
		"email": "maggie@auth0.com",
		"gravatarUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-2-122458e6b7.png",
		"profile": {
			"position": "Head of Sales",
			"company": "Auth0",
			"hobbies": "Tennis, Driving",
			"age": "33",
			"location": "Jersey City, US"
		},
		"sampleAppUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-2-app-3c930cb339.jpg",
		"connection": {
			"name": "Active Directory",
			"icon": "db"
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/components/LockHomeDemo/data/persons.json
// module id = 1094
// module chunks = 0